module.exports = "/_next/static/images/wrench-6cf910b0d37e6794b035dcf5049e4b9b.svg";